import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-postal-market',
  templateUrl: './postal-market.component.html',
  styleUrls: ['./postal-market.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class PostalMarketComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
